import { Switch } from 'react-native';

export default Switch;
